var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEpamLogoWhitecolor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 703.1 366.5",
    style: {
      enableBackground: "new 0 0 703.1 366.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#49BED7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.2,151.2h30.1v-33.3c0-9.3-4.4-14-13.4-14h-3.4c-8.9,0-13.4,4.7-13.4,14L182.2,151.2L182.2,151.2z  M182.2,172.5l0.1,36.6c0,9.3,4.5,13.9,13.4,13.9h3.9c8.9,0,13.4-4.6,13.4-13.9v-18h20.5v17.1c0,23.5-11.4,35.5-34,35.5H195 c-22.6,0-34-11.9-34-32.7v-89.5c0-26.3,11.4-38.2,34-38.2h4.5c22.6,0,34,11.9,34,35.4l-0.1,53.7L182.2,172.5L182.2,172.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.4,214.6c5.8,5.2,12.5,8.1,19.5,8.1c7.8,0,12.3-3.8,12.3-12.8v-93c0-9-4.5-12.8-12.3-12.8 c-7,0-13.7,2.9-19.5,8.1V214.6z M247.2,85.1h21.2v10.2c5-5.5,13.6-11.9,25.9-11.9c18.1,0,27,12.5,27,31.1v98.2 c0,18.6-8.9,31.1-27,31.1c-12.3,0-20.9-6.1-25.9-11.3v50.6h-21.2V85.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M384.8,215.5v-51.7l-19.2,7.6c-7.8,3.2-10.3,7.3-10.3,16.3v23.8c0,7.6,3.6,11.3,10.3,11.3 C372,222.8,377.9,220.5,384.8,215.5 M334.1,187.3c0-19.5,6.1-27.3,22.3-33.1l28.4-10.2v-26.1c0-9.3-4.5-14.2-13.4-14.2H368 c-8.9,0-13.4,4.9-13.4,14.2v22.2H334v-21.3c0-23.5,11.4-35.4,34-35.4h4c22.6,0,34,11.9,34,35.4V242h-21.2v-9.9 c-5.8,5.8-13.7,11.6-25.9,11.6c-17,0-24.8-10.2-24.8-27.6V187.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M491.6,242h-21.2V115.6c0-7.8-3.6-11.3-10-11.3c-5.8,0-12,2.3-19.5,7.8V242h-21.2V85.1h21.2v10.2 c6.2-6.1,14.2-12,25.9-12c10.9,0,18.1,4.7,22,12.8c7.6-6.7,16.5-12.8,28.7-12.8c16.4,0,24.8,10.5,24.8,27.6v131h-21.2V115.6 c0-7.8-3.6-11.3-10-11.3c-5.8,0-12,2.3-19.5,7.8L491.6,242L491.6,242z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "79.5,153.5 79.5,174.7 133.9,228 133.9,198.5 98.3,163.8 133.9,128.4 133.9,99.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "569.2,128.4 604.8,163.8 569.2,198.6 569.2,228 623.6,174.7 623.6,153.5 569.2,99.5  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpamLogoWhitecolor);
export default __webpack_public_path__ + "static/media/EPAM_logo_white+color.0eea2eb455930fadd13b13b2c52c1c3a.svg";
export { ForwardRef as ReactComponent };